const Constants = {
    menuPathMetadataKey: "MENU_PATH",
    itemMetadataKey: "ITEM",
    layoutGroupMetadataKey: "LAYOUT_GROUP",
    layoutMetadataKey: "LAYOUT",
    propertyGroupsMetadataKey: "property_groups",
    defaultServiceUrlLocalhost: "http://localhost/VikingDS_DEV",
    configuratorUrlPath: "/configurator/",
    modelSelectorUrlPath: "/model_selector/",
    summaryUrlPath: "/summary/",
    serviceUrlQueryParam: "service_url",
    languageUrlQueryParam: "lang",
    marketUrlQueryParam: "market",
    accountUrlQueryParam: "account",
    enableErrorConfirmationQueryParam: "enable_error_confirmation",
    hideNavigationButtonsQueryParam: "hide_navigation_buttons",
    customerEmailSubjectSettingsKey: "PDF_EMAIL_CUSTOMER_SUBJECT",
    customerEmailBodySettingsKey: "PDF_EMAIL_CUSTOMER_BODY_HTML",
    rootMenuId: "ROOT_MENU",
    genericFilterKey: "GENERIC",
    // Backend non-selection furniture sentinel (nova: SdsFurnitureOption.NonSelectionRetailerId,
    // assigned in SdsFurnitureLogicBuilder). A nova test pins this exact value. Items with this
    // article number are selectable "empty" tiles with no real Serie, so they are excluded from
    // filter facets. Match the exact value — a "__" prefix alone is NOT a non-selection (real
    // products such as test QR codes also use that prefix).
    nonSelectionArticleNumber: "__no_item",
    sideMenuWidth: 400,
    menuItemWidth: 93,
    menuItemHeight: 176,
    menuItemPriceHeight: 44,
    menuItemMarginRight: 18,
    menuItemmargeinBottom: 10,
    highResSideMenuWidth: 400 * 1.5,
    highResMenuItemWidth: 93 * 1.5,
    highResMenuItemHeight: 176 * 1.5,
    highResMenuItemPriceHeight: 44 * 1.5,
    highResMenuItemMarginRight: 18 * 1.5,
    highResMenuItemmargeinBottom: 10 * 1.5,
};

export default Constants;
